import { Button } from 'antd';
import React, {FC} from 'react';

import {ModalOpenerComponent} from 'components/modal-opener-component';
import {ActionButton} from 'components/table/action/action-button';
import {ITableActionProps} from 'components/table/action/table-action-types';
import { EButtonType } from 'entities/metadata';
import {TEntity} from 'modules/data';

import {useProjectInvestmentInfoItemModal} from '../hooks';
import { PROJECT_INVESTMENT_INFO_ITEM_MODAL_BUTTON_TYPE, PROJECT_INVESTMENT_INFO_ITEM_MODAL_TAB_KEYS } from '../model/project-investment-info-item-modal.constants';
import {ProjectInvestmentInfoItemModalForm} from './project-investment-info-item-modal-form';

interface IProjectInvestmentInfoItemModalOpenerProps extends ITableActionProps {
    record?: TEntity;
    buttonViewType?: typeof PROJECT_INVESTMENT_INFO_ITEM_MODAL_BUTTON_TYPE[keyof typeof PROJECT_INVESTMENT_INFO_ITEM_MODAL_BUTTON_TYPE];
    buttonTitle?: string;
    tabKey?: typeof PROJECT_INVESTMENT_INFO_ITEM_MODAL_TAB_KEYS[keyof typeof PROJECT_INVESTMENT_INFO_ITEM_MODAL_TAB_KEYS];
}

export const ProjectInvestmentInfoItemModalOpener: FC<IProjectInvestmentInfoItemModalOpenerProps> = ({
    meta,
    wrapper,
    entityName,
    record,
    buttonViewType = PROJECT_INVESTMENT_INFO_ITEM_MODAL_BUTTON_TYPE.PRIMARY,
    buttonTitle,
    tabKey = PROJECT_INVESTMENT_INFO_ITEM_MODAL_TAB_KEYS.MAIN,
    ...props
}: IProjectInvestmentInfoItemModalOpenerProps) => {
    const {
        modalRef,
        isOpen,
        isLoading,
        form,
        activeTab,
        setActiveTab,
        setIsOpen,
        handleCloseModal,
        handleFinish,
    } = useProjectInvestmentInfoItemModal({entityName, wrapper, record, tabKey});

    const getButtonComponent = () => {
        const title = meta.actionTitle || buttonTitle;

        switch (buttonViewType) {
            case PROJECT_INVESTMENT_INFO_ITEM_MODAL_BUTTON_TYPE.DETAIL:
                return <Button type={EButtonType.link} size="middle">
                    {title}
                </Button>
            case PROJECT_INVESTMENT_INFO_ITEM_MODAL_BUTTON_TYPE.PRIMARY:
                return <ActionButton {...props} buttonType={EButtonType.primary} actionIcon='PlusCircleOutlined'>
                    {title}
                </ActionButton>
            case PROJECT_INVESTMENT_INFO_ITEM_MODAL_BUTTON_TYPE.LINK_DATA:
                return <Button type={EButtonType.link}>
                    {record?.investProjectId}
                </Button>
            default:
                return undefined;
        }
    }

    return (
        <ModalOpenerComponent
            ref={modalRef}
            isOpen={isOpen}
            isLoading={isLoading}
            setIsOpen={setIsOpen}
            handleSave={() => {
                form.submit();
            }}
            handleCancel={setIsModalOpen => {
                handleCloseModal(setIsModalOpen);
            }}
            controlLabels={{save:
                    buttonViewType === PROJECT_INVESTMENT_INFO_ITEM_MODAL_BUTTON_TYPE.PRIMARY
                        ? 'Добавить проект' : 'Сохранить'}}
            component={(
                getButtonComponent()
            )}
            modalProps={{
                title: buttonViewType === PROJECT_INVESTMENT_INFO_ITEM_MODAL_BUTTON_TYPE.PRIMARY
                    ? 'Новая запись' : `Проект: ${record?.investProjectId}`,
                forceRender: true,
                centered: true,
                destroyOnClose: true,
            }}
        >
            {isOpen && <ProjectInvestmentInfoItemModalForm
                form={form}
                handleFinish={handleFinish}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
            />}
        </ModalOpenerComponent>
    );
};

